import { __awaiter } from "tslib";
import readyState from 'ready-state';
import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import Injector from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import SearchResultsObservable from '../observers/searchResultsObservable';
import BlueshiftObserver from '../blueshift/blueshiftObserver';
import Blueshift from '../blueshift/blueshift';
import './standalonePageEntrypointBanner';
import LoyaltyOfferService from '../services/loyaltyOfferService';
import Heap from '../heap/heap';
import { name as CashbackSearchResultsBannerInjectorName } from '../loyalty/cashbackSearchResultsBannerInjector';
import '@slickdeals/blueprint-twig/javascript/components/icon';
import '../patterns/inlineResponse';
import { initPage } from '../utilities/initPage';
import { trackSearchImpression, trackSearchAction, trackSearchRefinementAction } from '@slickdeals/web-instrumentation';
/** The name of the module */
export const name = 'Search';
initPage();
// Register observable with observer
const observer = new BlueshiftObserver(new Blueshift());
observer.observe(new SearchResultsObservable());
const addCashbackBannerPromo = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const offersJSON = yield LoyaltyOfferService.getOffers();
    const { offers } = offersJSON;
    const banner = document.querySelector('[data-promo-type="cashbackSearchResultsBanner"]');
    const offer = offers[Object.keys(offers)[0]];
    if (banner) {
        const heap = new Heap();
        heap.track(`${banner.dataset.trackingKey} - Impression`, { testVariant: banner.dataset.variantType }).catch(() => { });
    }
    else if (!banner && offer) {
        const props = {
            cashbackRate: offer.rate,
            ctaText: offersJSON.ctaText,
            ctaUrl: offersJSON.ctaUrl,
            storeName: offer.storeName,
            trackingKey: (_a = offersJSON.trackingKey) !== null && _a !== void 0 ? _a : 'Cashback Search Banner',
            testVariant: (_b = offersJSON.testVariant) !== null && _b !== void 0 ? _b : null,
        };
        const bannerInjector = Injector.resolve(CashbackSearchResultsBannerInjectorName);
        bannerInjector.injectBanner(props);
    }
});
const trackImpression = () => {
    const results = document.querySelectorAll('.resultRow, .coupon-content');
    const deals = Array.from(results).map((result) => {
        var _a, _b, _c, _d;
        return ({
            uniqueId: result.getAttribute('data-thread-id') || result.getAttribute('data-threadid'),
            dealTitle: ((_a = result.querySelector('.dealWrapper a')) === null || _a === void 0 ? void 0 : _a.textContent.trim()) || ((_b = result.querySelector('.frontpage-coupon-info a')) === null || _b === void 0 ? void 0 : _b.textContent.trim()) || '',
            isExpired: result.classList.contains('expired') || result.querySelector('.threadInfo').classList.contains('expired'),
            listPriceText: ((_c = result.querySelector('.oldListPrice')) === null || _c === void 0 ? void 0 : _c.textContent.trim()) || '',
            finalPriceText: ((_d = result.querySelector('.price')) === null || _d === void 0 ? void 0 : _d.textContent.trim()) || '',
        });
    });
    const page = document.querySelector('.currentPageNum');
    const currentPage = parseInt((page === null || page === void 0 ? void 0 : page.textContent.trim()) || '0');
    trackSearchImpression(currentPage, deals);
};
const getOptions = (section) => {
    if (!section) {
        return [];
    }
    const options = section.querySelectorAll('li, option');
    return Array.from(options).map((option) => {
        var _a, _b;
        const radioInput = option.querySelector('input[type="radio"]');
        const checkboxInput = option.querySelector('input[type="checkbox"]');
        const hiddenInput = option.querySelector('input[type="hidden"]');
        let value = '';
        let label;
        let checked;
        let type;
        if (radioInput) {
            value = radioInput.value || '';
            label = ((_a = option.querySelector('label')) === null || _a === void 0 ? void 0 : _a.textContent.trim()) || '';
            checked = radioInput.checked;
        }
        else if (checkboxInput) {
            value = checkboxInput.value || '';
            label = ((_b = option.querySelector('label')) === null || _b === void 0 ? void 0 : _b.textContent.replace(/\s*\(.*?\)\s*/g, '').trim()) || '';
            checked = checkboxInput.checked;
        }
        else if (option.tagName === 'OPTION') {
            value = option.getAttribute('value') || '';
            label = option.textContent.trim() || '';
            checked = option.hasAttribute('selected');
        }
        else if (hiddenInput) {
            value = (hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.value) || '';
            label = option.textContent.trim() || '';
            type = hiddenInput.getAttribute('data-type') || '';
        }
        return {
            value,
            label,
            checked,
            type,
        };
    });
};
const createSearchAction = () => {
    var _a;
    const urlParams = new URLSearchParams(window.location.search);
    const data = {
        searchTerm: urlParams.get('q') || '',
        totalResults: parseInt(((_a = document.querySelector('.numResults .semibold')) === null || _a === void 0 ? void 0 : _a.textContent.replace(/,/g, '').trim()) || '0', 10),
        searchSortBy: urlParams.get('sort') || 'relevance',
    };
    const sections = document.querySelectorAll('.section');
    const filters = Array.from(sections).map((section) => {
        var _a, _b, _c;
        let options = Array.from(section.querySelectorAll('.options'))
            .map((optionsElement) => getOptions(optionsElement))
            .reduce((optionsArray, opts) => optionsArray.concat(opts), []);
        options = options.filter((option, index, self) => index === self.findIndex((o) => o.value === option.value));
        const label = ((_a = section.querySelector('.sectionTitle')) === null || _a === void 0 ? void 0 : _a.textContent.trim()) || '';
        let filterLabel = section.getAttribute('data-filter');
        if (!filterLabel) {
            if (label === 'Display Options') {
                filterLabel = 'display';
            }
            else if (label === 'Search In') {
                filterLabel = 'search_in';
            }
            else {
                filterLabel = '';
            }
        }
        return {
            multiple: section.querySelector('input[type="checkbox"]') !== null,
            label,
            filterLabel,
            max: parseInt(((_b = section.querySelector('input[name="pricemax"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('value')) || '', 10) || null,
            min: parseInt(((_c = section.querySelector('input[name="pricemin"]')) === null || _c === void 0 ? void 0 : _c.getAttribute('value')) || '', 10) || null,
            expanded: section.querySelector('.icon-arrow-up') !== null,
            options,
        };
    });
    return {
        data,
        filters,
    };
};
const trackSearch = () => {
    const searchAction = createSearchAction();
    trackSearchAction(searchAction.data, searchAction.filters);
};
const trackSearchRefinement = () => {
    const searchAction = createSearchAction();
    trackSearchRefinementAction(searchAction.data, searchAction.filters);
};
const getOptionsMobile = (section) => {
    const opts = section.querySelectorAll('.option');
    const options = Array.from(opts).map((opt) => ({
        checked: opt.classList.contains('selected') || opt.getAttribute('selected') !== null,
        label: opt.textContent.trim(),
        value: opt.getAttribute('data-value') || '',
    }));
    const filterLabel = section.querySelector('.options').getAttribute('data-type') || '';
    const labels = {
        rating: 'Rating',
        hideexpired: 'Display Options',
        previousdays: 'Date',
        searcharea: 'Forum',
    };
    return {
        expanded: section.querySelector('.options').getAttribute('style') === 'display: block;',
        filterLabel,
        label: labels[filterLabel] || '',
        max: null,
        min: null,
        multiple: false,
        options,
    };
};
const createSearchActionMobile = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const data = {
        searchTerm: urlParams.get('q') || '',
        totalResults: 0,
        searchSortBy: urlParams.get('sort') || 'relevance',
    };
    const optionGroups = document.querySelectorAll('.optionGroup');
    const filters = Array.from(optionGroups).map((optionGroup) => getOptionsMobile(optionGroup));
    return {
        data,
        filters,
    };
};
const trackSearchMobile = () => {
    const searchAction = createSearchActionMobile();
    trackSearchAction(searchAction.data, searchAction.filters);
};
const trackSearchRefinementMobile = () => {
    const searchAction = createSearchActionMobile();
    trackSearchRefinementAction(searchAction.data, searchAction.filters);
};
readyState.domready.then(() => __awaiter(void 0, void 0, void 0, function* () {
    new LazyLoad(); // eslint-disable-line no-new
    try {
        yield addCashbackBannerPromo();
    }
    catch (_c) {
        Logger.error('Unable to load loyalty offers');
    }
    try {
        trackImpression();
    }
    catch (_d) {
        Logger.error('Unable to track search impression');
    }
    document.addEventListener('searchRefinementTriggered', () => {
        trackSearchRefinement();
    });
    document.addEventListener('searchRefinementTriggeredMobile', () => {
        trackSearchRefinementMobile();
    });
    const forumFilter = document.getElementById('forumFilter');
    if (forumFilter) {
        const options = forumFilter.querySelector('.options');
        if (options) {
            const mutationObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' && options.querySelectorAll('li').length > 0) {
                        trackSearch();
                        mutationObserver.disconnect();
                        break;
                    }
                }
            });
            mutationObserver.observe(options, { childList: true });
        }
    }
    else {
        trackSearchMobile();
    }
}));
